import { PermissionsService } from '@/core/services/permissions/permissions.service';
import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CameraGroupGuard implements CanActivate {
  private readonly permissions = inject(PermissionsService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.permissions.resolveMe().pipe(
      map(() => {
        const hasAccess =
          this.permissions.hasPermission('can_see_camera_group_tab') ||
          this.permissions.isMasterAdmin();

        if (!hasAccess) {
          this.router.navigate(['/minhas-cameras']);
          return false;
        }

        return true;
      }),
    );
  }
}
